import { useState } from "react";
import lumiereImg from "./images/materiels/lumiere.jpg";
import sonImg from "./images/materiels/son.jpg";
import videoImg from "./images/materiels/video.jpg";
import distriElec1Img from "./images/materiels/distri_elec_1.png";
import distriElec2Img from "./images/materiels/distri_elec_2.png";

function Materiels() {

    const [activeItem, setActiveItem] = useState("lumiere");

     const items = [
        { label: "Lumière", value: "lumiere" },
        { label: "Son", value: "son" },
        { label: "Vidéo", value: "video" },
        { label: "Distribution Électrique", value: "distri_elec" }
    ];

    const images = {
        lumiere: [lumiereImg],
        son: [sonImg],
        video: [videoImg],
        distri_elec: [distriElec1Img, distriElec2Img]
    };

    return(
      <div>
        <div className="materiels-header">
            {items.map((item) => (
                <p
                key={item.value}
                className={`materiels-item ${activeItem === item.value ? "active" : ""}`}
                onClick={() => setActiveItem(item.value)}
                >
                    {item.label}
                </p>
            ))}
        </div>
        <div className="materiels-photos">
            {images[activeItem].map((img, index) => (
                <img key={index} src={img} alt={`Materiels ${activeItem} ${index + 1}`} className="materiel-photo" />
            ))}
        </div>
      </div>
      
    )

}

export default Materiels;